export default __webpack_public_path__ + "static/media/delete-account.65cbed52.svg";